import { useNavigate } from 'react-router-dom'

export const useSalesListItem = (inId: string, outId?: string | undefined) => {
  const navigate = useNavigate()


  return {  navigate }
}
